// UserSettingStore.js
import { configureStore } from '@reduxjs/toolkit';
import userSettingReducer, { LS_AI_CONFIG_KEY } from './UserSettingSlice';

// LocalStorage保存用ミドルウェア
const localStorageMiddleware = store => next => action => {
  const result = next(action);

  // 設定変更アクションの場合のみ保存を実行
  if (
    action.type === 'userSetting/updateAiCoderConfig' ||
    action.type === 'userSetting/updateAiAgentConfig'
  ) {
    const state = store.getState().userSetting;
    try {
      localStorage.setItem(LS_AI_CONFIG_KEY, JSON.stringify(state.aiConfig));
    } catch (e) {
      console.error('Failed to save AI settings to LocalStorage', e);
    }
  }
  return result;
};

const userSettingStore = configureStore({
  reducer: {
    userSetting: userSettingReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localStorageMiddleware)
});

export default userSettingStore;